// Same-folder imports with `.ts`: the Node test runner can't resolve `@/`.
import { trialOfferParamKey } from './constants.ts';
import { handoffDistinctIdParam, handoffFailedParam } from './inAppHandoff.ts';

/**
 * The query strings `SignUp` (`src/pages/signUp/SignUp.tsx`) carries on after the visitor signs up.
 *
 * `ph_id` and the `handoff` fallback marker are dropped from both. `PostHogProvider` strips it from the window
 * URL, but the router was created before that and still has it, so without
 * this the phone's PostHog id would end up in a bookmarkable portal URL and a
 * reload would bootstrap PostHog with it.
 */
export const getSignUpParams = (searchParams: URLSearchParams) => {
  const oauth = new URLSearchParams(searchParams);
  oauth.delete(handoffDistinctIdParam);
  oauth.delete(handoffFailedParam);

  // The LinkedIn and Slack return keeps the offer code: their callbacks
  // (LinkedInCallback.tsx, SlackSignInCallback.tsx) need it to apply the
  // trial, then strip it. The in-app navigation drops it here so it doesn't
  // linger in a bookmarkable/shareable portal URL.
  const app = new URLSearchParams(oauth);
  app.delete(trialOfferParamKey);

  const oauthQuery = oauth.toString();
  return {
    oauthReturnTo: oauthQuery ? `/?${oauthQuery}` : '/',
    appQuery: app.toString(),
  };
};
